import { useEffect, useState } from 'react';
import { Api } from '../../componentes/Api';
import { Card, Form,  Row,Col,CardBody, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter } from "reactstrap"
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
import moment from "moment";
import { Offcanvas } from 'react-bootstrap';
import ReactInputMask from 'react-input-mask';

import PizZip from "pizzip";
import Docxtemplater from "docxtemplater";
import { saveAs } from "file-saver";


const modeloDatos = {
    clienteID: 0,
    nombre:"",
    apellidos:"",
    telefono: "",
    iD: "",
    direccion:"",
    sector:"",
    pueblo:"",
    ciudad:"",
    direccionmapa:"",
    creadoPor: "",
    modificadoPor: "",
    fechaCreado: new Date,
    fechaModificado: new Date,
    eliminado:false
   
}
const modeloDatos1 = {
    clienteRecibeID: 0,
    empresaID: 0,
    clienteID: 0,
    nombreRecibe: "",
    apellidosRecibe: "",
    telefono: "",
    telefono1: "",
    direccion: "",
    sector: "",
    pueblo: "",
    referencia: ""
};

const Version = () => {
    const [tabla1, setTabla1] = useState(modeloDatos1);
    const [tabla, setTabla] = useState(modeloDatos);
    const [Listado, SetListado] = useState([]);
    const [Listado1, SetListado1] = useState([]);
    const [Listado2, SetListado2] = useState([]);
    const [pendiente, setPendiente] = useState(true);
    const [verModal, setVerModal] = useState(false);
    const [verMovil, setverMovil] = useState(false);
    const [Recibe, setRecibe] = useState(false);
    const [Controlfecha, setControlfecha] = useState();
    const [busqueda, setbusqueda] = useState();
    const [user, setUser] = useState(window.localStorage.getItem("sesion_usuario"))
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);



    const handleChange = (e) => {
        let value = e.target.nodeName === "SELECT" ? (e.target.value == "true" ? true : false) : e.target.value;
        setTabla({
            ...tabla,
            [e.target.name]: value
        })
    }
    let correo = JSON.parse(user).correo;

    const onChangeb = async (e) => {
        var l = Listado1;
        setbusqueda(e.target.value);
        console.log(e);
        var searchData = l.filter((item) => {
            if (
              (  item.telefono + item.nombre )
                    .toString()
                    .toLowerCase()
                    .includes(e.target.value.toLowerCase())
            ) {
                return item;
            } 
        });
        SetListado(searchData);
    };

    const obtenerDatos = async () => {
        let response = await fetch(Api + "Transporte/listaClientes" );
        if (response.ok) {
            let data = await response.json()
         
            SetListado1(data)
            
                SetListado  (data)
         
            setPendiente(false)
       
           
           
        }
    }
    const obtenerDatos1 = async (c) => {
        let response = await fetch(Api + "Transporte/listaClientesRecibe/"+c );
        if (response.ok) {
            let data = await response.json()
         
            SetListado2(data)
            
        }
    }

    useEffect(() => {
        obtenerDatos();
    },[])


    const mostrarMensaje = () => {
        Swal.fire({
            title: 'ERROR',
            text: "No puedes guardar si hay un elemento Activo.  Favor inactivar el elemento. ",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            //confirmButtonText: 'Si, continuar',
            cancelButtonText: 'volver'
        }).then((result) => {
            //alert(result.value)
            if (result.value) {


            }
        })

    }


    const guardarCambios = async () => {
        let response;
        if (tabla.clienteID == 0) {
            tabla.creadoPor = JSON.parse(user).correo;
            response = await fetch(Api + "Transporte/GuardarClientes", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })
            setVerModal(!verModal);
        } else {
            tabla.modificadoPor = JSON.parse(user).correo;
            response = await fetch(Api + "Transporte/EditarClientes", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })
        }

        if (response.ok) {
            setPendiente(true)
            obtenerDatos();

            Swal.fire(
                'Guardado!',
                '' + tabla.nombre,
                'success'
            )
        
            if (tabla.activa == false) {
                setTabla(modeloDatos);
                setVerModal(!verModal);
            }
            let data1 = await response.json()

            if (data1 == false) {
                mostrarMensaje()
            } else {
                await obtenerDatos();
                setTabla(modeloDatos)
                setVerModal(!verModal);
            }
         
        } else {
            alert("error al guardar")
        }

    }

    const eliminarDatos = async (id) => {

        Swal.fire({
            title: 'Esta seguro?',
            text: "Desea eliminar el producto",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, continuar',
            cancelButtonText: 'No, volver'
        }).then((result) => {
            if (result.value) {
                const response = fetch(Api + "Citas/EliminarEspecialistas/" + id, { method: "DELETE" })
                    .then(response => {
                        if (response.ok) {
                            obtenerDatos();
                            Swal.fire(
                                'Eliminado!',
                                'El producto fue eliminado.',
                                'success'
                            )
                        }
                    })
            }
        })
    }

    const abrirEditarModalMovil = (data) => {
        setTabla(data);
        setverMovil(!verMovil);
    }
    const abrirEditarModal = (data) => {
        setTabla(data);
        setVerModal(!verModal);
    }
    const cerrarModal = () => {
        setTabla(modeloDatos)
        setVerModal(false)
        setverMovil(false)
    }

    const columns = [
        {
            name: 'Telefono',
            selector: row => (<>
                {
                    <a href={"https://api.whatsapp.com/send?phone=1" + row.telefono.replace(/-/g, "")} target="_blank" >   
                    {row.telefono}</a>}
            </>),
            sortable: true,
          /*  omit: window.innerWidth < 844,*/
            width: window.innerWidth < 844 ? '30%' : '20%',
         
        },
        {
            name: 'Nombre ',
            selector: row => row.nombre,
            sortable: true,
            width: window.innerWidth < 844 ? '40%'  : '20%',

        },
       
      
             {
            name: 'Direccion',
                 selector: row => row.direccion,
                 omit: window.innerWidth < 844,
                 sortable: true,

        },  {
            name: 'ID',
            selector: row => row.id,
                 sortable: true,
            width: '20%',
                 omit: window.innerWidth < 844,

        },
        {
            name: '',
           

            cell: row => (
                <>
                    <Button color="primary" size="sm" className="mr-2"
                        onClick={() => abrirEditarModal(row)}
                    >
                        <i className="fas fa-pen-alt"></i>
                    </Button>
                  
                    <Button color="success" className="mr-2" size="sm" onClick={()=> (handleShow(),setTabla(row))}>
                        <i className="fas fa-file"></i>

                    </Button>
                    <Button color="warning" className="mr-2" size="sm" onClick={() => (obtenerDatos1(row.clienteID), setRecibe(true), setTabla(row))}>
                        <i className="fas fa-list"></i>

                    </Button>
                </>
            ),
        },
    ];

    const customStyles = {
        headCells: {
            style: {
                fontSize: '13px',
                fontWeight: 800,
            },
        },
        headRow: {
            style: {
                backgroundColor: "#eee",
            }
        }
    };

    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };
    const handleChange1 = (e) => {
        const { name, value } = e.target;
        setTabla1({
            ...tabla1,
            [name]: value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        let response;
        if (tabla1.clienteRecibeID == 0) {
            tabla1.clienteID = tabla.clienteID;
            response = await fetch(Api + "Transporte/GuardarClientesRecibe", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla1)
            })
            setShow(false);
        } else {
         
            response = await fetch(Api + "Transporte/EditarClientesRecibe", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla1)
            })
        }

        if (response.ok) {
         
            Swal.fire(
                'Guardado!',
                '' + tabla1.nombreRecibe,
                'success'
            )

        
                setTabla1(modeloDatos1);
         
            
         

        } else {
            alert("error al guardar")
        }
    };

  
 
    const generarDocumento = async (x) => {
        try {
            const response = await fetch('/plantilla.docx');
            const arrayBuffer = await response.arrayBuffer();

            const zip = new PizZip(arrayBuffer);

            const doc = new Docxtemplater(zip, {
                paragraphLoop: true,
                linebreaks: true,
            });

            // Variables a reemplazar
            doc.render({
                nombre: tabla.nombre,
                apellidos: tabla.apellidos,
                telefono: tabla.telefono,
                direccion: tabla.direccion,
                sector: tabla.sector,
                pueblo: tabla.pueblo,
                nombreRecibe: x.nombreRecibe,
                apellidosRecibe: x.apellidosRecibe,
                telefonoRecibe:x.telefono,
                telefonoRecibe1: x.telefono1,
                direccionRecibe: x.direccion,
                sectorRecibe: x.sector,
                puebloRecibe: x.pueblo,
                dia: moment(new Date()).format("DD"),
                hora: moment(new Date()).format("HH"),
                minuto: moment(new Date()).format("mm"),
                lic: tabla.iD


            });

            const blob =  doc.getZip().generate({
                type: 'blob', mimeType:
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
 });
            saveAs(blob, 'cliente' + tabla.nombre + ' ' + tabla.apellidos +'.docx');

            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url; a.download = 'cliente' + tabla.nombre + ' ' + tabla.apellidos + '.docx';
            document.body.appendChild(a); a.click();
            URL.revokeObjectURL(url);

        } catch (error) {
            console.error('⛔ Error al generar el documento Word:', error);
            if (error.properties && error.properties.errors) {
                console.log('Detalles:', error.properties.errors);
            }
        }
    };


    return (
        <>
         

            <Offcanvas show={show} onHide={handleClose} placement="end">
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>   <h4>Registro Cliente que Recibe de {tabla.nombre}</h4>
</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <Form onSubmit={handleSubmit} className="p-3 border rounded shadow-sm bg-light">
                     
                     

                        <FormGroup>
                            <Label>Nombre que Recibe</Label>
                            <Input type="text" name="nombreRecibe" value={tabla1.nombreRecibe} onChange={handleChange1} />
                        </FormGroup>   <FormGroup>
                            <Label>Apellido que Recibe</Label>
                            <Input type="text" name="apellidosRecibe" value={tabla1.apellidosRecibe} onChange={handleChange1} />
                        </FormGroup>
<Row>
                            <Col md="6">             <FormGroup>
                            <Label>Teléfono</Label>
                                <ReactInputMask class="form-control" mask="999-999-9999" bsSize="sm" name="telefono" onChange={handleChange1} value={tabla1.telefono} />

                            </FormGroup>
                        </Col>
                            <Col md="6">     <FormGroup>
                            <Label>Teléfono 2</Label>
                                <ReactInputMask class="form-control" mask="999-999-9999" bsSize="sm" name="telefono1" onChange={handleChange1} value={tabla1.telefono1} />

                            </FormGroup> </Col>
</Row>
                        <FormGroup>
                            <Label>Dirección</Label>
                            <Input type="text" name="direccion" value={tabla1.direccion} onChange={handleChange1} />
                        </FormGroup>

                        <FormGroup>
                            <Label>Sector</Label>
                            <Input type="text" name="sector" value={tabla1.sector} onChange={handleChange1} />
                        </FormGroup>
                                       <FormGroup>
                            <Label>Pueblo</Label>
                            <Input type="text" name="pueblo" value={tabla1.pueblo} onChange={handleChange1} />
                        </FormGroup>

                        <FormGroup>
                            <Label>Referencia</Label>
                            <Input type="text" name="referencia" value={tabla1.referencia} onChange={handleChange1} />
                        </FormGroup>

                        <Button color="primary" type="submit">Guardar</Button>
                    </Form>

                </Offcanvas.Body>
            </Offcanvas>
            <Card>
                <CardHeader style={{ backgroundColor: '#4e73df', color: "white" }}>
                    Lista de Clientes
                </CardHeader>
                <CardBody>
                 <Row>  
                    <Col md="8">
                    <Input type="search" name="busqueda" onChange={(e) => onChangeb(e)} placeholder="Busqueda por telefono / nombre " ></Input>
                        </Col>
                        <Col md="4">     <Button color="success" size="sm"
                        onClick={() => (setVerModal(!verModal), setTabla(modeloDatos))}
                    >Nuevo Cliente</Button></Col></Row> 
                    <hr></hr>
                    <DataTable
                        columns={columns}
                        data={Listado}
                        progressPending={pendiente}
                        pagination
                        paginationComponentOptions={paginationComponentOptions}
                        customStyles={customStyles}
                    />
                </CardBody>
            </Card>

            <Modal isOpen={verModal} className="modal-preguntas">
                <ModalHeader className=" modal-header1" toggert={cerrarModal}>
                    
                    <div class="box">
                        <div>         Mantenimiento de Cliente</div>
                        <div><a className="btn" style={{ color: "#ffff" }} onClick={() => cerrarModal()}>X</a></div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <Row>

                        <Col md="3">
                            <FormGroup>
                                <Label>Telefono</Label>
                                <ReactInputMask class="form-control" mask="999-999-9999" bsSize="sm" name="telefono" onChange={handleChange} value={tabla.telefono} />
                            </FormGroup>
                        </Col>
                        <Col md="3">
                    <FormGroup>
                      
                                <Label>Nombre </Label>
                                <Input bsSize="sm" name="nombre" onChange={handleChange} value={tabla.nombre} />
                            </FormGroup>
                        </Col>
                        <Col md="3">
                    <FormGroup>
                      
                                <Label>Apellidos </Label>
                                <Input bsSize="sm" name="apellidos" onChange={handleChange} value={tabla.apellidos} />
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label>ID / Lic</Label>
                                <Input bsSize="sm" name="id" onChange={handleChange} value={tabla.id} />
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label>Direccion</Label>
                                <Input bsSize="sm" type="textarea" name="direccion" onChange={handleChange} value={tabla.direccion} />
                            </FormGroup>
                        </Col>    <Col md="3">
                            <FormGroup>
                                <Label>Sector</Label>
                                <Input bsSize="sm" type="textarea" name="sector" onChange={handleChange} value={tabla.sector} />
                            </FormGroup>
                        </Col> <Col md="3">
                            <FormGroup>
                                <Label>Pueblo</Label>
                                <Input bsSize="sm" type="textarea" name="pueblo" onChange={handleChange} value={tabla.pueblo} />
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label>Direccion MAPA</Label>
                                <Input type="textarea" bsSize="sm" name="direccionmapa" onChange={handleChange} value={tabla.direccionmapa} />
                            </FormGroup>
                        </Col>
                  
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button size="sm" color="primary"
                        onClick={guardarCambios}
                    >Guardar</Button>
                    <Button size="sm" color="danger"
                        onClick={cerrarModal}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={verMovil}>
                <ModalHeader className=" modal-header1">
                    Datos de: {tabla.nombre}
                </ModalHeader>
                <ModalBody>
                    <Row>
                       
                        <Col md="12">
                            <FormGroup>
                            <a href={"https://api.whatsapp.com/send?phone=" + tabla.telefono} target="_blank" >    <img src="./imagen/whatsapp.png" style={{ width: "30px" }} />
                                {tabla.telefono}</a>
                            </FormGroup>
                        </Col>
                        <Col md="12">
                            <FormGroup>
                                
                                <a href={"tel:" + tabla.telefono} target="_blank" ><i class="fas fa-phone" style={{ width: "30px" }}></i>{tabla.telefono}</a>
                            </FormGroup>
                        </Col>
                       
                        <Col md="12">
                            <FormGroup>
                                <i class="fa fa-id-card"> </i>
                                {tabla.id}
                            </FormGroup>
                        </Col>
                        <Col md="12">
                            <FormGroup>
                             <a href={"" + tabla.direccionmapa} target="_blank" >   <img src="./imagen/mapa.png" style={{ width: "30px" }} />
                                {tabla.direccion}</a>
                              
                            </FormGroup>
                        </Col>
                  
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button size="sm" color="primary"
                        onClick={guardarCambios}
                    >Guardar</Button>
                    <Button size="sm" color="danger"
                        onClick={cerrarModal}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={Recibe} className="modal-preguntas">
                <ModalHeader className=" modal-header1">
                    Personas que reciben y direcciones de: {tabla.nombre}
                </ModalHeader>
                <ModalBody>
                    <Button color="success" className="mr-2" onClick={() => (handleShow(), setTabla(tabla), setRecibe(false))}>
                        <i className="fas fa-file"></i>

                    </Button>
                    <table>
                        <tr>
                            <th>Nombre</th>
                            <th>Telefono</th>
                            <th>Telefono2</th>
                            <th>Direccion</th>
                            <th>Pueblo</th>
                        </tr>
                        {Listado2.map(x => (
                            < tr >
                                <td>{x.nombreRecibe + " " + x.apellidosRecibe}</td>
                                <td>{x.telefono }</td>
                                <td>{x.telefono1 }</td>
                                <td>{x.direccion}</td>
                                <td>{x.pueblo}</td>
                                <td> <Button size="sm" color="primary"
                                    onClick={()=>generarDocumento(x)}
                                >Generar</Button></td>
                            </tr>))}
                    </table>

                  </ModalBody>
                <ModalFooter>
                  
                    <Button size="sm" color="danger"
                        onClick={()=>setRecibe(false)}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>



        </>
    )

}
export default Version;